<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'performance-manage',
    subject: 'Hr',
  },
})

const page = {
  groupTitle: 'Kepegawaian (HR)',
  icon: 'ri-bar-chart-grouped-line',
  color: 'info',
  title: 'Riwayat Penilaian Kinerja Pegawai',
  description: 'Melihat rekap penilaian kinerja seorang pegawai lintas periode.',
  purpose: 'Panduan melihat riwayat seluruh penilaian kinerja seorang pegawai dalam satu tampilan, lintas template penilaian.',
  concept: [
    {
      icon: 'ri-history-line',
      title: 'Rekap Lintas Template',
      text: 'Kalau seorang pegawai pernah dinilai lewat beberapa template berbeda dari waktu ke waktu, halaman ini merangkum semuanya jadi satu riwayat — tidak perlu buka satu-satu.',
    },
  ],
  steps: [
    { title: 'Buka menu Kepegawaian → Penilaian Kinerja', detail: 'Cari nama pegawai.' },
    { title: 'Lihat daftar seluruh penilaian yang pernah dilakukan', detail: 'Termasuk template yang dipakai, skor, dan tanggal.' },
  ],
  tips: [
    'Halaman ini murni untuk MELIHAT riwayat — untuk membuat penilaian baru, gunakan halaman "Penilaian & Skoring (Assessment)".',
  ],
  faq: [],
  related: [
    { title: 'Penilaian & Skoring (Assessment)', sub: 'Cara membuat penilaian baru', icon: 'ri-award-line', color: 'warning', to: { name: 'help-mutu-assessment-penilaian' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
